/* global apiUrl */
import Sortable from 'sortablejs' // 並べ替え

const drugSort = document.getElementsByClassName('js-drugSort')[0]

if (drugSort) {
  listDrug()
}

function listDrug() {
  const listApi = apiUrl + 'playlist/'

  const listId = drugSort.dataset.id

  const sortable = new Sortable(drugSort, {
    handle: '.js-drugSort-handle', // ハンドル要素
    filter: '.js-drugSort-disable', // ドラッグを禁止する要素
    ghostClass: 'js-drugSort-drop', // ドロップ中のクラス名の指定
    chosenClass: 'js-drugSort-select', // 選択中のクラス名の指定
    dragClass: 'js-drugSort-grip', // ドラッグ中のクラス名の指定
    animation: 150,
    scroll: true,
    onEnd: function (e) {
      let movieList = 'action=sort&list-id=' + listId + '&list='
      const drugItems = document.getElementsByClassName('js-drugSort-handle')
      for (let index = 0; index < drugItems.length; index++) {
        const element = drugItems[index]
        if (index !== 0) {
          movieList += ','
        }
        movieList += element.dataset.id
      }
      applyAjax(listApi, 'post', movieList)
    }, // ドラッグが終了した時
    // setData:function(e){} // データを格納・保存した時
    // onChoose:function(e){} // 要素を選択している時
    // onStart:function(e){} // ドラッグが開始された時
    // onEnd:function(e){} // ドラッグが終了した時
    // onAdd:function(e){} // リスト内に新たに要素が追加された時
    // onUpdate:function(e){} // ソートされリスト内が新たに更新された時
    // onSort:function(e){} // リストの変更（追加/更新/削除）がされた時
    // onRemove:function(e){} // 要素がリストから別のリストに移動し削除された時
    // onFilter:function(e){} // filterで指定された要素をドラッグしようとした時
    // onMove:function(e){} // リスト内またはリスト間で項目を移動した時
    // onClone:function(e){} // 要素が複製された時
  })

  let ajax
  /**
   * Ajax処理を実行する
   * @param url {string} 取得先のURL
   * @param from {string} 書き換え元のセレクタ　,区切りで複数指定
   * @param to {string} 取得先のセレクタ　,区切りで複数指定
   * @param pushSt {string|boolean} 擬似的にページ遷移する　falseじゃなければ有効
   * @param type {string} rep:要素を書き換える add:書き換え元の下に追加する
   * @param scroll {string} 指定の位置にスクロールさせる
   * @param flag {string} 独自の拡張用
   */
  function applyAjax(url, method = 'get', param) {
    if (ajax) {
      // 既に通信中なら切断
      ajax.abort()
    }

    ajax = new XMLHttpRequest() // Ajaxリクエスト
    if (method === 'post') {
      ajax.open(method, url, true) // GET/POST, URL, 非同期処理
    } else {
      if (param) {
        url += (~url.indexOf('?') ? '&' : '?') + param // パラメータをURLに結合
      }
      // Ajaxと明示するパラメータを付ける
      url += (~url.indexOf('?') ? '&' : '?') + 'ajax=1'
      ajax.open(method, url, true) // GET/POST, URL, 非同期処理
    }
    ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest') // Ajaxでのアクセスと明示するリクエストヘッダー
    // キャッシュせず最新のデータを取る場合のリクエストヘッダー3種
    // ajax.setRequestHeader('Pragma', 'no-cache')
    // ajax.setRequestHeader('Cache-Control', 'no-cache')
    // ajax.setRequestHeader('If-Modified-Since', 'Thu, 01 Jun 1970 00:00:00 GMT')
    if (method === 'post') {
      ajax.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded') // POST時に必要なリクエストヘッダー
    }
    ajax.responseType = 'document' // 取得タイプ document text json
    ajax.timeout = 10000 // タイムアウト判定時間
    if (method === 'post') {
      ajax.send(param) // POSTリクエスト実行
    } else {
      ajax.send() // GETリクエスト実行
    }
    ajax.onload = function () {
      // アクセス成功
      if (ajax.status < 200 || ajax.status >= 400) {
        console.log('Error: Code ' + ajax.status) // エラー
      }

      // // IEは取得タイプJSONをtextで受け取るのでJSONにパースする
      // if (navigator.userAgent.indexOf('Trident') !== -1 && JSON) {
      //   ajaxData = JSON.parse(ajaxData)
      // }
    }
    ajax.ontimeout = function (e) {
      // タイムアウト
    }
    ajax.onerror = function () {
      // Ajax処理失敗
    }
    ajax.onloadend = function () {
      // 受信成否に関わらず実行
      // intObsAjax()
      ajax = false
    }
  }
}
